import { useMemo, useEffect } from 'react';
import isUndefined from 'lodash/isUndefined';
import isFunction from 'lodash/isFunction';
import Breadcrumb from '@Services/Breadcrumb';
import { getCleanFamilyId } from '@Containers/PatentFamilyClustering/utils';

function useExpandPatentFamilyGroupFromBreadcrumb({ document, metadata }, callback) {
  const shouldExpandPatentFamilyGroup = useMemo(() => {
    const { databaseId, resultName } = metadata;
    const activeBreadcrumb = Breadcrumb.getBreadcrumbForDbByResultName(databaseId, resultName);
    return (
      !isUndefined(activeBreadcrumb.expandPatentFamilyGroup) && activeBreadcrumb.expandPatentFamilyGroup === getCleanFamilyId(document)
    );
  }, [document, metadata]);

  useEffect(() => {
    if (isFunction(callback) && shouldExpandPatentFamilyGroup) {
      callback();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return shouldExpandPatentFamilyGroup;
}

export default useExpandPatentFamilyGroupFromBreadcrumb;
